import React, {useCallback, useEffect, useLayoutEffect, useMemo, useState} from 'react';
import './index.scss';

import DrawingArea from '../../components/DrawingArea'
import {mapPoint} from "../utils/pointMaps";

// Компонент линии

interface Point {
    id: number;
    x: number;
    y: number;
}
// Компонент области рисования

interface propsGame {
    setModalOpen: React.Dispatch<React.SetStateAction<boolean>>,
    levelEnd: boolean,
    Img: string;
    id: string | undefined;
    setLevelEnd: React.Dispatch<React.SetStateAction<boolean>>
}

// Основной компонент
function Game(props: propsGame) {
    const {id, Img,  setModalOpen, levelEnd, setLevelEnd} = props
    useEffect(() => {
        setTimeout(() => {
            if (levelEnd)
                setModalOpen(true)
        }, 2000)
    }, [levelEnd])

    useEffect(() => {
        document.body.style.overflow = "hidden";
    }, []);

    const initialPoints: Point[] = mapPoint[Number(id) - 1 ]
    console.log(initialPoints)
    return (
        <div className="GameContainer">
            <DrawingArea id={id} points={initialPoints} pointClassProps={levelEnd ? 'wrapPontEnd' : ''}
                         setLevelEnd={setLevelEnd}/>
            <img className={`${levelEnd ? 'imgOpen' : ''} imgClose ${id && id === '6' ? 'megaphone' : ''}`} src={Img}/>
        </div>
    );
}

export default Game;
